(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfUibBtnRadio', function() {
    return {
      require: ['ngModel', 'uibBtnRadio'],
      restrict: 'A',
      link: function(scope, ele, attrs, ctrls) {
        var classesToToggle, customClasses, ngModelCtrl, uibBtnRadioRender, valToCheckAgainstModel;
        ngModelCtrl = ctrls[0];
        uibBtnRadioRender = ngModelCtrl.$render;
        valToCheckAgainstModel = scope.$eval(attrs.uibBtnRadio);
        customClasses = scope.$eval(attrs.mfUibBtnRadio);
        classesToToggle = customClasses || 'btn-primary';
        return ngModelCtrl.$render = function() {
          var isEqual;
          isEqual = angular.equals(ngModelCtrl.$modelValue, valToCheckAgainstModel);
          ele.toggleClass(classesToToggle, isEqual);
          return uibBtnRadioRender();
        };
      }
    };
  });

}).call(this);
